(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
  })();
  (function() {
  if (!__sections__["finance-selection"] && !window.DesignMode) return;
  try {
    

    theme.FinanceBreakdown = function(){
        var selectors = {
            optionSelect: '.select_option',
            planSelect: '.select_plan',
            products: '.finance-selection_products .product',
            price: '.product-details .price',
            monthlyText: '.product-details .monthly-text'
        };
        function FinanceBreakdown(container){
            this.container = container;
            this.sectionId = container.getAttribute('data-section-id')
            this.namespace = 'financeBreakdown-'+ this.sectionId
            this.init();
        }
        FinanceBreakdown.prototype = Object.assign({}, FinanceBreakdown.prototype, {
            init: function(){
                //set selectors 
                this.optionSelector = this.container.querySelector(selectors.optionSelect);
                this.planSelector   = this.container.querySelector(selectors.planSelect);

                this.bindCallbacks();
                this.bindEvents();
                this.initSelectors();
                setTimeout(() => {
                    this.updatePrice();
                }, 500);
            },
            bindCallbacks: function(){
                this.changePlanBound = this.updatePlan.bind(this);
                this.changeOptionBound = this.updateOption.bind(this);
            },
            bindEvents: function(){
                this.planSelector.addEventListener('change', this.changePlanBound, false);
                this.optionSelector.addEventListener('change', this.changeOptionBound, false);     
            },
            initSelectors: function(){
                this.currentPlan = this.planSelector.selectedOptions[0].value
                this.currentOption = this.optionSelector.selectedOptions[0].value;
            },
            updatePlan: function(){
                this.currentPlan = this.planSelector.selectedOptions[0].value
                this.updatePrice();
            },
            updateOption: function(){
                this.currentOption = this.optionSelector.selectedOptions[0].value;
                this.updatePrice();
            },
            updatePrice: function(){
                this.container.querySelectorAll(selectors.products).forEach( ( product )=> {
                    var priceDiv = product.querySelector(selectors.price);
                    var variants = JSON.parse(product.dataset.variants);
                    var options  = JSON.parse(product.dataset.options);
                    var model    = product.dataset.model;
                    //var currentVariant = variants.filter( variant => {
                    //    return variant.option1 == this.currentOption  
                    //})

                    var currentOption = [{
                        index: "option1", //option1 is always size
                        value: this.currentOption
                    }]
                    var currentVariant = theme.utils.searchUpsellValues(currentOption, variants, model, options );
                    if(currentVariant.length > 0){
                        var currentProductVariant = theme.utils.getUpsellVariantFromOptions(currentVariant, variants)
                    }

                    if(currentProductVariant){
                        product.classList.remove('hidden')
                         
                        
                        if(affirm.ui.ready() && this.currentPlan != "Pay Now" ){
                            var options = {
                                apr: "0.0", // percentage assumed APR for loan
                                months: this.currentPlan, // can be 3, 6, or 12
                                amount: currentProductVariant.price, // USD cents
                            };

                            product.querySelector(selectors.monthlyText).style.display = "inline";
                            affirm.ui.payments.get_estimate(options,  function (payment_response){
                                priceDiv.textContent = theme.Currency.formatMoney(payment_response.payment, '${{amount_no_decimals}}')
                            });
                        }else{
                            priceDiv.textContent = theme.Currency.formatMoney(currentProductVariant.price, '${{amount_no_decimals}}')
                            product.querySelector(selectors.monthlyText).style.display = "none";

                        }
                    }else{
                        product.classList.add('hidden')
                    }
                })     
            },
        });

        return FinanceBreakdown;
    }();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["instagram-feed"] && !window.DesignMode) return;
  try {
    
    fetch('https://ig.instant-tokens.com/users/188157a4-daf1-4851-9839-903eedff3889/instagram/17841401820367764/token?userSecret=ufpnxd5q5jrmbndedfh8s')

    .then((response) => {
      response.json().then((data) => {
      var instagramFeed = new Instafeed({
          get: 'user',
          target: "instafeed-container",
          template: '<a href="{{link}}"><img loading="lazy" width="auto" height="auto" class="image__img" title="{{caption}}" src="{{image}}" /><div class="image__overlay"><div class="image__title"><i class="fa-brands fa-instagram"></i></div></div></a>',
          accessToken: data.Token,
          resolution: 'standard_resolution',
          limit: 9
        });
          instagramFeed.run();
      });
    });
    
  } catch(e) { console.error(e); }
})();

})();
